import { Fragment } from 'react';
import { Comment } from './Comment';
import { Comment as CommentType } from '~/lib/discussions/types';

export function Children({
  root,
  comments,
  mutateComment,
  moderator = false,
  isReview = false,
}: {
  root: CommentType;
  comments: CommentType[];
  mutateComment: () => void;
  moderator?: boolean;
  isReview?: boolean;
}) {
  return (
    <>
      {comments.map((comment) => (
        <Fragment key={comment.id}>
          <Comment
            // '?p=1' query param forces preview/SSR page
            // root display path will already have ?p=1 if unapproved so we need to double check here
            href={`${root.display_path}${
              !comment.approved && !root.display_path.includes('?p=1')
                ? '?p=1'
                : ''
            }#${comment.id}`}
            comment={comment}
            moderator={moderator}
            mutateComment={mutateComment}
            border
            className="mt-10"
            isReview={isReview}
          />
          {comment.children && comment.children.length > 0 && (
            <div className="pl-4 sm:pl-12">
              <Children
                root={root}
                comments={comment.children}
                moderator={moderator}
                mutateComment={mutateComment}
                isReview={isReview}
              />
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
}
